export default {
  page: {
    title: 'Agrupador de palabras',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Agrupador de palabras',
  },
  form: {
    wordsPerGroup: {
      label: 'Palabras',
      placeholder: 'Cantidad de palabras por grupo',
    },
    groupsPerMagazine: {
      label: 'Grupos',
      placeholder: 'Cantidad de grupos por revistas',
    },
    totalMagazines: {
      label: 'Revistas',
      placeholder: 'Cantidad de revistas',
    },
    wordsList: {
      label: 'Lista de palabras',
    },
    totalWords: {
      label: 'Total de palabras:',
    },
    magazine: {
      label: 'Revista',
    },
    group: {
      label: 'Grupo',
    },
  },
  button: {
    shuffle: 'Mezclar la lista de palabras',
    generate: 'Generar grupos de palabras',
    copyMagazine: 'Copiar palabras de la revista',
    copyWords: 'Copiar palabras',
  },
  alert: {
    shuffled: 'Lista mezclada con éxito',
    generated: 'Grupos generados con éxito',
    insufficientWords:
      'Falta {count} palabra para formar los grupos | Faltan {count} palabras para formar los grupos',
  },
};
